/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} searchResultsClickResetFacetsParams
* @property {string} availableFacets - json with all availabel facets
* @property {string} clickOrigin - empty_result_page
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {boolean} isDemo - True|False
* @property {string} selectedFacets - json with all selected facets, in case no facets chosen this is null!
* @property {string} target - what does user search for (term, phrase, word)
**/
/**
 * Name: Search Results > Facets Reset. Evid: 307.
 * Event description: user clicked clear filters in result page.

 * availableFacets - Type: string. Desc: json with all availabel facets
 *
 * clickOrigin - Type: string. Desc: empty_result_page
 *
 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * selectedFacets - Type: string. Desc: json with all selected facets, in case no facets chosen this is null!
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 * @param {searchResultsClickResetFacetsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchResultsClickResetFacets = function (params) {
    return { evid: 307, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} wixSearchBarClickXParams
* @property {boolean} isDemo - True|False
**/
/**
 * Name: Search Results > Search Bar's "x" clicked. Evid: 309.
 * Event description: Should be sent after visitor submitted search in Search Result by clicking 'Enter'.

 * isDemo - Type: bool. Desc: True|False
 * @param {wixSearchBarClickXParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixSearchBarClickX = function (params) {
    return { evid: 309, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} loadingFinishedParams
* @property {string} error - error message
* @property {number} loadingDuration - time  between loading.started and loading.finished,ms
* @property {boolean} success - True|False
**/
/**
 * Name: [to be deprecated] searchResults.loading.finished. Evid: 302.
 * Event description: Event should be sent when widget rendering finished.

 * error - Type: string. Desc: error message
 *
 * loadingDuration - Type: numeric. Desc: time  between loading.started and loading.finished,ms
 *
 * success - Type: bool. Desc: True|False
 * @param {loadingFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingFinished = function (params) {
    return { evid: 302, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} documentTypeChangeParams
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {boolean} isDemo - True|False
* @property {string} source - ViewAll|Tab
* @property {string} tabName - the tab the user clicked in the search results page, in case user navigates between tabs
* @property {string} target - all|pages|products|blogPosts
**/
/**
 * Name: Search Results > Tab Changed. Evid: 306.
 * Event description: Event should be sent on result tab click (one of All/Pages/Products/BlogPost) or viewAll.

 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * source - Type: string. Desc: ViewAll|Tab
 *
 * tabName - Type: string. Desc: the tab the user clicked in the search results page, in case user navigates between tabs
 *
 * target - Type: string. Desc: all|pages|products|blogPosts
 * @param {documentTypeChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var documentTypeChange = function (params) {
    return { evid: 306, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} searchRequestStartedParams
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {string} documentType - pages|products|blog
* @property {boolean} isDemo - True|False
* @property {string} orderingDirection - Ordering direction, one of:  ASC, DESC.
* @property {string} orderingFieldName - Ordering field name
* @property {string} target - what does user search for (term, phrase, word)
**/
/**
 * Name: [to be deprecated] searchResults - request was sent to server. Evid: 303.
 * Event description: Should be sent after visitor has been submitted search and request was sent to server.

 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * documentType - Type: string. Desc: pages|products|blog
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * orderingDirection - Type: string. Desc: Ordering direction, one of:  ASC, DESC.
 *
 * orderingFieldName - Type: string. Desc: Ordering field name
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 * @param {searchRequestStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchRequestStarted = function (params) {
    return { evid: 303, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} documentClickParams
* @property {string} clickOrigin - image/title/add_to_cart
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {string} documentId - Unique id for each vertical's document
* @property {string} documentType - all|pages|products|blogPosts
* @property {boolean} isDemo - True|False
* @property {string} pageUrl - URL
* @property {string} resultClicked - the result title the user clicked on
* @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
* @property {number} searchIndex - index of the clicked item from search result set (search_index starts from 0)
* @property {string} target - past was page title since 03-21 it is the search term  the user wrote
**/
/**
 * Name: Search Results > Result Clicked. Evid: 305.
 * Event description: Event should be sent on visitor's click on Search Result.

 * clickOrigin - Type: string. Desc: image/title/add_to_cart
 *
 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * documentId - Type: string. Desc: Unique id for each vertical's document
 *
 * documentType - Type: string. Desc: all|pages|products|blogPosts
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * pageUrl - Type: string. Desc: URL
 *
 * resultClicked - Type: string. Desc: the result title the user clicked on
 *
 * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
 *
 * searchIndex - Type: numeric. Desc: index of the clicked item from search result set (search_index starts from 0)
 *
 * target - Type: string. Desc: past was page title since 03-21 it is the search term  the user wrote
 * @param {documentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var documentClick = function (params) {
    return { evid: 305, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} loadingStartedParams

**/
/**
 * Name: [to be deprecated] searchResults.loading.started. Evid: 301.
 * Event description: Should be sent after visitor has been redirected to the search results page and rendering process for widget started.


 * @param {loadingStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingStarted = function (params) {
    return { evid: 301, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} searchRequestFinishedParams
* @property {string} availableFacets - json with all availabel facets
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {string} documentIds - {"public/stores/products": ["id1", "id2", ...], "public/blog/posts": ["id1", "id2", ...], ...}
* @property {string} documentType - pages|products|blog
* @property {string} error - error message
* @property {boolean} isDemo - True|False
* @property {number} loadingDuration - time between request.sent and request.resultReceived
* @property {string} orderingDirection - Ordering direction, one of: ASC, DESC.
* @property {string} orderingFieldName - Ordering field name
* @property {string} origin - why the result page was loaded?  tab_change/editor_search_bar/result_page_search_bar/direct_visit/sort/page_change/facets
* @property {number} resultCount - result count for specific document type
* @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
* @property {string} selectedFacets - json with all selected facets, in case no facets chosen this is null!
* @property {boolean} success - true|false
* @property {string} target - what does user search for (term, phrase, word)
**/
/**
 * Name: Search Results > Results Shown. Evid: 304.
 * Event description: Should be sent after visitor has been submitted search and request result was received.

 * availableFacets - Type: string. Desc: json with all availabel facets
 *
 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * documentIds - Type: string. Desc: {"public/stores/products": ["id1", "id2", ...], "public/blog/posts": ["id1", "id2", ...], ...}
 *
 * documentType - Type: string. Desc: pages|products|blog
 *
 * error - Type: string. Desc: error message
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * loadingDuration - Type: numeric. Desc: time between request.sent and request.resultReceived
 *
 * orderingDirection - Type: string. Desc: Ordering direction, one of: ASC, DESC.
 *
 * orderingFieldName - Type: string. Desc: Ordering field name
 *
 * origin - Type: string. Desc: why the result page was loaded?  tab_change/editor_search_bar/result_page_search_bar/direct_visit/sort/page_change/facets
 *
 * resultCount - Type: numeric. Desc: result count for specific document type
 *
 * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
 *
 * selectedFacets - Type: string. Desc: json with all selected facets, in case no facets chosen this is null!
 *
 * success - Type: bool. Desc: true|false
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 * @param {searchRequestFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchRequestFinished = function (params) {
    return { evid: 304, src: 99, endpoint: 'wix-search-widget', params: params };
};
/**
* @typedef {Object} searchSubmitParams
* @property {GUID} correlationId - guid should be unique for the search per visitor
* @property {boolean} isDemo - True|False
* @property {string} target - what does user search for (term, phrase, word)
**/
/**
 * Name: Search Results > Search Submitted. Evid: 300.
 * Event description: Should be sent after visitor submitted search in Search Result by clicking 'Enter'.

 * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
 *
 * isDemo - Type: bool. Desc: True|False
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 * @param {searchSubmitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchSubmit = function (params) {
    return { evid: 300, src: 99, endpoint: 'wix-search-widget', params: params };
};
//# sourceMappingURL=index.js.map